import React, { useEffect } from "react";

import vectorblack from "../../../assets/svg/vectorblack.svg";
import DMSLogo from "../../../assets/svg/DMSLogo.svg";
import TMSLogo from "../../../assets/svg/TMSLogo.svg";
import GALogo from "../../../assets/svg/GALogo.svg";
import $ from "jquery";

const AppLauncher = ({ isOpen, setisOpen, isAdminAccess }) => {

    useEffect(() => {
        if (isOpen == true) {
            let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("appLauncherScreen"));
            myOffcanvas.show();
        }
        if (isOpen == false) {
            document.getElementById("appLauncherClose")?.click();
        }
    }, [isOpen]);

    // const handleAppDMSLauncher = () => {
    //     window.open(process.env.REACT_APP_DMS_URL);
    //     setisOpen(false)
    // }

    const handleAppTMSLauncher = () => {
        window.open(process.env.REACT_APP_TAS_URL);
        setisOpen(false)
    }

    const handleAppGALauncher = () => {
        window.open(process.env.REACT_APP_GA_URL);
        setisOpen(false)
    }

    const cancelBackdrop = () => {
        $("#appLauncherScreen").removeClass("show");
        setisOpen(false)
    }

    return (
        <> 
         {$("#appLauncherScreen").hasClass("show") ? <div className='viewbar-overlay' id="closeCanvas" onClick={cancelBackdrop}></div> : <></>}
            <div className="offcanvas offcanvas-start offcanvasStyleApp" tabIndex={-1} style={{zIndex: 9999}}  data-bs-scroll="false" data-bs-backdrop="false" id="appLauncherScreen" aria-labelledby="offcanvasScrollingLabel">
                <div className="offcanvas-body applauncher-padding scroll-hide" id="scrolloffcanvas">
                    <div className="row">
                        <>
                            <div className="col-12">
                                <img
                                    src={vectorblack}
                                    className="cursor-pointer app-image-hover"
                                    onClick={() => setisOpen(false)}
                                />
                                <br />
                                <label className="app-head app-image">Apps</label>
                               <br />

                                {/* 
                                <div className="cursor-pointer" onClick={() => handleAppDMSLauncher()}>
                                    <img src={DMSLogo} className="app-image cursor-pointer" />
                                    <label className="app-label cursor-pointer pt-20">
                                        &nbsp;&nbsp;Document&nbsp;management&nbsp;system
                                    </label>
                                </div>
                                 <br /> */}

                                <div className="cursor-pointer mt-3" onClick={() => handleAppTMSLauncher()}>
                                    <img src={TMSLogo} className="app-image cursor-pointer" />
                                    <label className="app-label cursor-pointer">
                                        &nbsp;&nbsp;Training Administration System
                                    </label>
                                </div>
                               {/* <br />  */}
                                    <div className="cursor-pointer mt-3" onClick={() => handleAppGALauncher()}>
                                        <img src={GALogo} className="app-image cursor-pointer" />
                                        <label className="app-label cursor-pointer">&nbsp;&nbsp;Global Admin</label>
                                    </div>
                            </div>
                        </>
                        <button className="d-none" id="appLauncherClose" data-bs-dismiss="offcanvas">Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppLauncher;
